import React from "react";
import { Box } from "@mui/material";
import { ReactComponent as AlertIcon } from  "../../../../assets/icons/alert.svg";
import i18next from "i18next";
import Button from "../../../../components/buttons/Buttons";
import styles from "./updateVehicleStatus.module.scss";
import PropTypes from "prop-types";

const UpdateVehicleStatus= (props) => {
  const { handleDelete, handleCancel } = props;

  return (
    <Box
    className={styles.deleteCertificateWrapper}
    data-testid="UpdateVehicleStatus"
  >
    <Box className={styles.alertIcon}>
      <AlertIcon />
    </Box>
    <Box className={styles.contentWrapper}>
      <Box className={styles.description}>
        {i18next.t("Selected certificate will be deleted")}
      </Box>
    </Box>

    <Box></Box>
    <Box className={styles.buttonWrapper}>
      <Button
        title="Cancel"
        iconStyle={""}
        buttonType="muibtn-secondary"
        withIcon={false}
        handleClick={handleCancel}
      />
      <Button
        title="Yes, delete"
        iconStyle={""}
        buttonType="muibtn-primary"
        withIcon={false}
        handleClick={handleDelete}
      />
    </Box>
  </Box>
  );
};

export default UpdateVehicleStatus;
UpdateVehicleStatus.propTypes = {
  handleDelete:PropTypes.any, 
  handleCancel:PropTypes.any
}
